<div class="div-breadcrumb">
  <div class="div-crumb" *ngFor="let crumb of breadcrumb; let i = index">
    <a class="crumb-link" *ngIf="crumb.link" [routerLink]="[crumb.url]">{{crumb.name}}</a>
    <span class="crumb-span" *ngIf="!crumb.link">{{crumb.name}}</span>
    <span class="crumb-span" *ngIf="i < breadcrumb.length - 1"> > </span>
  </div>
</div>
